<template>
  <div class="flex item-level-container">
    <div class="list-group question-list">
      <template v-for="q in questions">
        <button
          type="button"
          :class="['list-group-item', q.questionKey === selectedQuestionKey ? 'active' : null]"
          :key="`question-${q.questionKey}`"
          @click="selectedQuestionKey = q.questionKey"
        >
          {{ q.uniqueKey }}
        </button>
      </template>
    </div>
    <response-chart
      :item-level-data="itemLevelData"
      :question="questions[selectedQuestionKey]"
      :key="selectedQuestionKey"
    />
  </div>
</template>

<script>
  import ResponseChart from './ResponseChart';
  export default {
    props: ['questions', 'characters', 'itemLevelData'],

    components: {
      ResponseChart,
    },

    data() {
      return {
        selectedQuestionKey: Object.values(this.questions)[0].questionKey,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .item-level-container {
    & > :first-child {
      width: 30%;
    }
    & > :last-child {
      width: 70%;
    }
    height: 400px;

    & > .question-list {
      height: 400px;
      overflow-y: scroll;
    }
    .list-group-item {
      height: 46px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
